<template>
  <div id="chat-container">
    <div>
      <ChatWindowHeader></ChatWindowHeader>
    </div>
    <div id="chat-thread">
      <ChatThread :thread="thread" :assistantTyping="assistantTyping" :messageSignature="messageSignature" :lead="lead"></ChatThread>      
    </div>
    <ChatInput
      v-if="
        !(
          lead.status == 'requested' ||
          scheduledTime.status == 'requested'
        )
      "
    ></ChatInput>
  </div>
</template>

<script setup>
import ChatInput from "./ChatInput.vue";
import ChatThread from "./ChatThread.vue";
import ChatWindowHeader from "./ChatWindowHeader.vue";
import { useMessagesStore } from "@/stores/useMessagesStore";
import { storeToRefs } from "pinia";
import { useLeadStore } from "@/stores/useLeadStore";
import { observeDateTime } from "@/services/ScheduleService";

const { thread, assistantTyping, messageSignature } = storeToRefs(useMessagesStore());

const leadStore = useLeadStore();
const { lead } = storeToRefs(leadStore);
const scheduledTime = observeDateTime();

</script>

<style scoped>
#chat-container {
  width: 100%;
  height: 100%;
  min-height: 300px;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
}

#chat-thread {
  flex-grow: 1;
  overflow-y: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
  background-color: white;
  /* Ensure smooth scrolling on iOS */
  -webkit-overflow-scrolling: touch;
}

#chat-thread * {
  overflow-anchor: none;
}

#anchor {
  overflow-anchor: auto;
  height: 1px;
}

#chat-thread::-webkit-scrollbar {
  display: none;
}

#special_messages {
  padding-left: 24px;
  padding-right: 24px;
}
</style>
